import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { Button } from '@/components/button'
import { Group } from '@/components/form'
import { createModal, useModalize } from '@/components/modalize/mui'
import { colors, fontSizes, fontWeights } from '@/styles'
import { headKey } from '@/utils'

const Header = styled.div`
  background-color: ${colors.white};
  height: 120px;
  position: sticky;
  top: 0;
`

const Title = styled.h4`
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.medium};
  text-align: center;
  width: 100%;
  padding: 48px 0 20px;
`

const StyledGroup = styled(Group)`
  flex: 1;
  margin: 10px;
  padding: 25px 30px;
  margin: 0;
`

const Disclaimer = styled.p`
  padding: 15px 30px;
  margin: 0;
  border-bottom: 1px solid ${colors.grey};
`

const StyledText = styled.p`
  margin: 15px 0 30px 0;
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px 0;
  align-items: center;
  > button {
    width: 100%;
  }
`

const CloneModal = ({ values, title = 'Re-list existing unit?', history, listingId }) => {
  const { close } = useModalize()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const showBlankForm = async () => {
    const response = await dispatch.listing.create(values)
    close()
    if (response.response.ok) {
      const newlistingId = headKey(response.body.listings)
      history.replace(`/listing/create-old/${newlistingId}`)
    }
  }

  const duplicateData = async () => {
    const { body, error } = await dispatch.listing.cloneListing(listingId)
    if (!error) {
      close()
      const newlistingId = headKey(body.listings)
      history.replace(`/listing/create-old/${newlistingId}`)
    }
  }

  return (
    <>
      <Header>
        <Title>{title}</Title>
      </Header>
      <Disclaimer>
        {t('l.listing.relist_modal.description', 'It seems you have created this unit before.')}
      </Disclaimer>
      <StyledGroup>
        <StyledText>
          {t(
            'l.listing.relist_modal_clone.description',
            'How would you like us to help you with your listing creation?'
          )}
        </StyledText>
        <ButtonWrapper>
          <Button name="license_pill" theme="primary" onClick={duplicateData}>
            {t('l.listing.relist_modal_duplicate.button', 'Duplicate my old data')}
          </Button>
          <Button name="license_pill" theme="primary" onClick={showBlankForm}>
            {t('l.listing.relist_modal_continue.button', 'Continue with blank form')}
          </Button>
        </ButtonWrapper>
      </StyledGroup>
    </>
  )
}

export const showCloneModal = createModal(CloneModal)
